import React, { useRef } from 'react';
import { object } from 'prop-types';
import { Field, reduxForm } from 'redux-form';
import { useDispatch } from 'react-redux';

import './Services.css';

import { Link } from "react-router-dom";
import { SET_SHOW_MODAL_LEGAL } from '../../actions/types';
let checkboxSequence = 0;
function CustomCheckBox  ({
    input: { value, onChange, ...input },
    meta: { touched, error },
    name,
    inline,
    label,
    feedback,
    privacyAgreement,
    ...rest
  }) { 
    const dispatch = useDispatch();
    // Contact and modal forms can be mounted together with the same field name.
    const checkboxIdRef = useRef(null);
    if (!checkboxIdRef.current) checkboxIdRef.current = `${name || input.name || 'checkbox'}-${++checkboxSequence}`;
    const checkboxId = checkboxIdRef.current;
    const showError = Boolean(touched && error);
    let isInline = inline ? 'form-check-inline' : '';
    let isInvalid = '';

    if(touched && error ){
      isInvalid = 'is-invalid';
    } else if(touched && !error){
      isInvalid = '';

    }
    function renderLabel(){
      if(privacyAgreement){
        return (
          <>
            Seznámil/a jsem se s <span className="fake-link-span" onClick={() => dispatch({type: SET_SHOW_MODAL_LEGAL, payload: {show: true, legalType: 'conditions'}})}>obchodními podmínkami</span> a <span className="fake-link-span" onClick={() => dispatch({type: SET_SHOW_MODAL_LEGAL, payload: {show: true, legalType: 'private'}})}>informacemi o zpracování osobních údajů</span>.
          </>
        );
      }
      return label;
    }
    return (
        <>
          <div className={`form-check ${isInline} ${isInvalid}`}>
            <input className={`form-check-input ${isInvalid} custom-checkbox`} type="checkbox" id={checkboxId} {...input}
            {...rest} checked={!!value} aria-invalid={showError} aria-describedby={showError ? `${checkboxId}-error` : undefined}
            onChange={e => onChange(e.target.checked)}/>
            <label className="form-check-label" htmlFor={checkboxId}>{renderLabel()} </label>
            {showError && <div id={`${checkboxId}-error`} className="invalid-feedback d-block" role="alert">
              {error || feedback}
            </div>}
          </div>
        </>
       
  )};
  
  CustomCheckBox.propTypes = {
    input: object.isRequired,
    meta: object.isRequired
  };
  
  CustomCheckBox.defaultProps = {
    input: null,
    meta: null
  };
  
  export default props => <Field {...props} component={CustomCheckBox} />;

  
        {/*
           <Form.Check
        {...input}
        {...rest}
        defaultChecked={!!value}
        onChange={e => onChange(e.target.checked)}
        type="checkbox"
        inline={inline}
        isInvalid={touched && error}
        isValid={touched && !error}
      />
        */}
